import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import DialogModal from "../../common/DialogModal";
import Button from "../../Parts/Button";
import NotificationBar from "../../Parts/NotificationBar.jsx";
import { formatName, addCommas } from "../../../utils/utils";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: "25px",
    margin: 0,
  },

  deleteContentContainer: {
    padding: "50px 50px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "450px",
    boxSizing: "border-box",
    background: "#FFFFFF",
    textAlign: "left",
  },

  emptyContainer: {
    padding: "50px",
    position: "relative",
    background: "#FFFFFF",
    border: "1px solid #D8DBDF",
    boxSizing: "border-box",
    width: "100%",
  },

  container: {
    background: "#FFFFFF",
    border: "1px solid #D8DBDF",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  alertName: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start",
    boxSizing: "border-box",
  },

  buttonContainer: {
    width: "100%",
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  title: {
    textAlign: "left",
    fontWeight: "bold",
    fontSize: "13px",
    color: "#71737B",
    marginBottom: "10px",
  },

  flex: {
    flex: 1,
  },

  row: {
    marginBottom: "22px",
    width: "100%",
    boxSizing: "border-box",
  },

  sectionTitle: {
    fontSize: "16px",
    marginBottom: "14px",
    fontWeight: "bold",
    padding: "8px 0px 11px 0px",
    borderBottom: "1px solid #D8DBDF",
    width: "100%",
    boxSizing: "border-box",
    textAlign: "left",
  },

  text: {
    margin: 0,
    padding: 0,
    fontSize: "16px",
    maxWidth: "410px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    textAlign: "left",
  },

  alertCountText: {
    paddingLeft: "10px",
  },

  alert: {
    marginTop: "11px",
    fontSize: "16px",
    fontWeight: "bold",
    textAlign: "left",
    color: '#f03a47',
  }
});

class CsvDownloadDialog extends React.Component {
  state = {};

  displayDialogText = () => {
    let dialogText = 'アドレス';
    // キーマンデータベースの場合は文言の表示を「キーマン」に変更する
    if (document.URL.match("/executive-list")) {
      dialogText = 'キーマン';
    }
    return dialogText;
  };

  renderNotification = () => {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          top: 10,
          left: "calc(50% - 100px)",
        }}
      >
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false });
          }}
          autoClose={true}
          animation="fade"
        ></NotificationBar>
      </div>
    );
  };

  renderRow = (tag, index, isLast = false) => {
    const { classes } = this.props;

    return (
      <div
        className={classes.row}
        key={index}
        style={{ borderBottom: isLast ? "none" : "1px solid #D8DBDF" }}
      >
        <Typography variant="subheading">{tag}</Typography>

        <div className={classes.flex}></div>

        <Button
          type="ghost"
          text="除外"
          handleClickButton={this.toggleDeleteDialog(tag)}
          style={{ width: "70px", minWidth: "unset", padding: "0px" }}
        ></Button>
      </div>
    );
  };

  render() {
    const { classes, toggleDialog, isOpen, selectCount, activePlan, item, exportedList } = this.props;
    const dialogText = this.displayDialogText();
    const count = item ? 1 : selectCount;

    const unitPrice = `¥${addCommas(activePlan.export_unit_price)}`;
    const totalPrice = `¥${addCommas(activePlan.export_unit_price * count)}(税別)`;

    return (
      <DialogModal
        title={`選択した${dialogText}をCSVでダウンロード`}
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <NotificationBar
          message={item ? `${formatName(item, "様")}の情報を選択中` : `${addCommas(count)}件の${dialogText}を選択中`}
          type="ghost"
          open={true}
          autoClose={false}
          disableOnclickListener={true}
          style={{
            transform: "none",
            boxShadow: "none",
            width: "100%",
            boxSizing: "border-box",
            marginBottom: "20px",
          }}
          animation="none"
        ></NotificationBar>
        <div className={classes.row}>
          <div className={classes.sectionTitle}>単価</div>
          <p className={classes.text}>{unitPrice}</p>
        </div>

        <div className={classes.row}>
          <div className={classes.sectionTitle}>料金</div>
          <p className={classes.text}>{totalPrice}</p>
        </div>

        <div>
          {exportedList.count() > 0 && (
            <div>
              <div className={classes.row}>
                <div className={classes.sectionTitle}>選択したキーマンで過去ダウンロード済みのキーマン</div>
                <div className={classes.alertName}>
                  <div>
                    {formatName(exportedList.first(), "様")}
                  </div>
                  {exportedList.count() > 1 && (
                    <div className={classes.alertCountText}>
                      ...他{addCommas(exportedList.count() - 1)}件
                    </div>
                  )}
                </div>
                <div className={classes.alert}>除外したい場合は、検索条件の絞りこみオプションで「ダウンロード済みを除外」を条件に含めて検索してください。</div>
              </div>
            </div>
          )}
        </div>
        <div className={classes.buttonContainer}>
          <Button
            style={{ width: '48%' }}
            handleClickButton={this.props.toggleDialog}
            size="large"
            text="キャンセル"
            type="ghost"
          ></Button>
          <Button
            style={{ width: '48%' }}
            handleClickButton={() => {
              if (item === null) {
                this.props.handleCsvExportAll();
              } else {
                this.props.handleCsvExportOne(item.id);
              }
              this.props.toggleDialog();
            }}
            size="large"
            text="CSVダウンロード"
          ></Button>
        </div>
      </DialogModal>
    );
  }
}

CsvDownloadDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  handleCsvExportAll: PropTypes.func.isRequired,
  handleCsvExportOne: PropTypes.func.isRequired,
  selectCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  exportedList: PropTypes.object,
  activePlan: PropTypes.object,
  item: PropTypes.object,
};

export default withStyles(styles)(CsvDownloadDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/CsvDownloadDialog.jsx